export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;
export const LOGIN_PAGE_NAME =
  process.env.REACT_APP_LOGIN_PAGE_NAME || "Success Academy";
export const LOGIN_PAGE_TAGLINE =
  process.env.REACT_APP_LOGIN_PAGE_TAGLINE ||
  "CA | CS | CMA | Online Lectures for CA CS CMA";
export const LOGIN_PAGE_LOGO =
  process.env.REACT_APP_LOGO || "/success-academy-logo.png?v=3";